import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import { addCollection } from '@iconify/vue'
import biIcons from '@iconify-json/bi/icons.json'
import App from './App.vue'
import router from './router'

addCollection(biIcons)

createApp(App)
  .use(createBootstrap())
  .use(router)
  .mount('#app')
